declare let THREE: any;

export class TitleBlockCanvas extends (THREE.Mesh as { new(geometry, material): any; }) {

    private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
    static readonly Name = 'TitleBlock';

  
    constructor() {
      
  
      const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(TitleBlockCanvas.rotationTransform);
      const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });
      super(geometry, material);
  
      this.name = TitleBlockCanvas.Name;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/TitleBlock/Index.ts